import { Card, Space } from 'antd';
import GridPhotos from 'components/commons/GridPhotos';

interface ReturnAndFailQCTemplateTypes {
  cardTitle: string;
  data: {
    title: string;
    content?: string;
    srcImage?: [];
  }[];
}

export default function ReturnAndFailQCTemplate({
  cardTitle,
  data,
}: ReturnAndFailQCTemplateTypes) {
  return (
    <Card title={cardTitle} className="!w-full">
      <Space direction="vertical" size={10}>
        {data.map((item, index) => (
          <div
            key={`return-information-${index.toString()}`}
            className="text-text-dark-gray"
          >
            <div className="font-bold mb-[5px]">{item.title}</div>
            {Array.isArray(item?.srcImage) && item?.srcImage?.length > 0 ? (
              <GridPhotos
                images={item?.srcImage}
                width={80}
                height={80}
                maxPreview={5}
                className="!mr-[5px]"
              />
            ) : (
              item?.content || '-'
            )}
          </div>
        ))}
      </Space>
    </Card>
  );
}
